<template>
  <div id="thanks-giving">
    <img src="../assets/images/tk-activity-bg.jpeg" />
    <div class="center-box">
      <div class="pcs section">
        <img src="../assets/images/tk-activity-title-pcs.png" />
        <div class="introduce">
          <p>充值满送，最低<span>7</span>折起，新用户注册即送<span>5</span>元体验金</p><a class="register" href="https://account.mopaas.com/registerPublic.jsp"
            target="_blank">点击注册</a>
        </div>
        <div class="price-box">
          <a class="price" v-for="item in prices" :key="item.id" href="https://account.mopaas.com/web/user/user_purse.jsp"
            target="_blank">
            <h2 :class="{'small-font':item.id > 2}">{{item.price}}</h2>
            <h5>{{item.rule}}</h5>
            <p>立即充值</p>
          </a>
        </div>
        <h5 class="second-title second-title-loc">多种场景随心选</h5>
        <div class="scence-box">
          <div class="scene" v-for="item in scenes" :key="item.id">
            <div class="dot">
              <div class="icon">
                <i class="iconfont" :class="item.icon" />
              </div>
              <h5>{{item.title}}</h5>
              <p>{{item.content}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="ai section">
        <img src="../assets/images/tk-activity-title-ai.png" style="margin: 80px 0 50px 0;" />
        <h5 class="second-title">
          降低AI技术门槛，释放AI技术潜力
        </h5>
        <div class="dot">
          <p>整合多种 AI 框架，高效地分配、管理、监控和调度超算的资源；对多台GPU服务器资源进行管理和调度，优化 GPU
            资源的利用率，降低成本；为平台用户以及管理人员提供相应的管理系统，通过友好直观的UI界面对资源进行管理操作。</p>
        </div>
        <h5 class="second-title">
          多种套餐可选，包年享<span style="color: #FEDB79;">8</span>折优惠
        </h5>
        <div class="plan-box">
          <div class="plan" v-for="item in plans" :key="item.id">
            <div class="detail">
              <div class="title">{{item.title}}</div>
              <div class="resources">
                <div>GPU: <span class="content">{{item.gpu}}</span></div>
                <div>CPU: <span class="content">{{item.cpu}}</span></div>
                <div>内存: <span class="content">{{item.mem}}</span></div>
              </div>
            </div>
            <div class="right-box">
              <div class="deco-up"></div>
              <div class="price">
                <div class="left">
                  <div class="line" style="margin-top: 26px;"><span>包月</span><span class="former">原价：{{item.formerMonth}}</span><span
                      class="now">现价：{{item.currentMonth}}</span></div>
                  <div class="line" style="margin-top: 18px;"><span>包年</span><span class="former">原价：{{item.formerYear}}</span><span
                      class="now">现价：{{item.currentYear}}</span></div>
                </div>
                <a class="buy-btn" href="https://ai.mopaas.com/#/user/recharge?active=pay" target="_blank">立即购买</a>
              </div>
              <div class="deco-down"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="weitu section">
        <img src="../assets/images/tk-activity-title-weitu.png" style="margin: 0px 0 50px 0;" />
        <h5 class="second-title">
          全方位的高效云管理平台
        </h5>
        <div class="dot">
          <p>为企业提供中立化、运维自动化、服务自助化、数据可视化、成本最优化等多云环境一站式解决方案。</p>
        </div>
        <h5 class="second-title">
          0元即可试用，包年可享最低<span style="color: #FEDB79;">1.82</span>折优惠
        </h5>
        <div class="plan-box">
          <div class="intro-box">
            <div class="detail">
              <h3>SaaS试用版</h3>
              <p>(试用期一个月)</p>
              <a href="http://weitu.mopaas.com/signin?redirect=%2Fsuperadmin%2Ftenants" target="_blank">0元试用</a>
            </div>
            <div class="resources" style="background-color: #016AC4;">
              <p>
                用户3个
                云环境1个
                主机5个
                对象存储Bucket 1个
                CDN域名1个
              </p>
            </div>
            <div class="resources" style="background-color: #0D7BDA;">
              <p>
                自定义工具10个
                作业10个
                文件管理存储空间1GB
                文件下载流量1GB
                告警规则10个
              </p>
            </div>
            <div class="resources" style="background-color: #248AE2;">
              <p>
                流程模型3个
                流程实例5个
                自定义模型1个
                各模型实例5个
              </p>
            </div>
          </div>
          <div class="plan">
            <div class="intro-box">
              <div class="detail">
                <h3>SaaS标准版</h3>
                <div class="buy-btn" @click="dialogVisible = true">立即购买</div>
              </div>
              <div class="resources" style="background-color: #016AC4;">
                <p>
                  用户10个
                  云环境5个
                  主机50个
                  对象存储Bucket2个
                  CDN域名2个
                </p>
              </div>
              <div class="resources" style="background-color: #0D7BDA;">
                <p>
                  自定义工具20个
                  作业100个
                  文件管理存储空间20GB
                  文件下载流量20GB
                  告警规则20个
                </p>
              </div>
              <div class="resources" style="background-color: #248AE2;">
                <p>
                  流程模型10个
                  流程实例2000个
                  自定义模型10个
                  各模型实例200个
                </p>
              </div>
            </div>
            <div class="price-box">
              <div class="inner-hidden">
                <div class="intro">
                  <p>费用说明：</p>
                </div>
                <div class="price">
                  <p class="now">
                    月付：810元/月
                  </p>
                  <p class="former">
                    原价：4448元/月
                  </p>
                </div>
                <div class="price">
                  <p class="now">
                    月付：7776元/月
                  </p>
                  <p class="former">
                    原价：42700元/月
                  </p>
                </div>
                <div class="price">
                  <p class="now">
                    月付：13600元/月
                  </p>
                  <p class="former">
                    原价：74726元/月
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="plan">
            <div class="intro-box">
              <div class="detail">
                <h3>SaaS旗舰版</h3>
                <div class="buy-btn" @click="dialogVisible = true">立即购买</div>
              </div>
              <div class="resources" style="background-color: #016AC4;">
                <p>
                  用户50个
                  云环境10个
                  主机200个
                  对象存储Bucket10个
                  CDN域名10个
                </p>
              </div>
              <div class="resources" style="background-color: #0D7BDA;">
                <p>
                  自定义工具100个
                  作业500个
                  文件管理存储空间100GB
                  文件下载流量100GB
                  告警规则50个
                </p>
              </div>
              <div class="resources" style="background-color: #248AE2;">
                <p>
                  流程模型50个
                  流程实例10000个
                  自定义模型50个
                  各模型实例1000个
                </p>
              </div>
            </div>
            <div class="price-box">
              <div class="inner-hidden">
                <div class="intro">
                  <p>费用说明：</p>
                </div>
                <div class="price">
                  <p class="now">
                    月付：2250元/月
                  </p>
                  <p class="former">
                    原价：12000元/月
                  </p>
                </div>
                <div class="price">
                  <p class="now">
                    月付：21600元/月
                  </p>
                  <p class="former">
                    原价：115200元/月
                  </p>
                </div>
                <div class="price">
                  <p class="now">
                    月付：54000元/月
                  </p>
                  <p class="former">
                    原价：201600元/月
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-dialog title="详询客服" :visible.sync="dialogVisible" width="445px">
          <div style="display: flex;align-items: center; justify-content:center;"><a style="text-decoration: none; font-size:14px; "
              href="http://wpa.qq.com/msgrd?v=3&amp;uin=2629198267&amp;site=qq&amp;menu=yes" target="_blank"><img src="@/assets/images/qq(2).png"
                style="width: 35px">
              <p style="margin-left:10px ;color: #349CE3;display: initial;font-size:14px;">2629198267</p>
            </a></div>
          <div style="display: flex;align-items: center; justify-content:center; margin-top:20px;"><img alt="" src="@/assets/images/phone.png"
              style="width: 29px;">
            <p style="margin-left:10px;color: #349CE3;font-size:14px;">021-54011298</p>
          </div>
        </el-dialog>
      </div>
      <div class="rule section">
        <img src="../assets/images/tk-activity-title-rule.png" style="margin: 0px 0 50px 0;" />
        <div class="rule-box">
          <div class="dot">
            <p>
              1.本次满减活动适用于公有云在线充值用户；
              2.满送仅限于单个订单额度，同一账户不同订单金额不叠加计算；
              3.同一账户不同订单情况下，凡单个订单满足条件的均可享受满送福利；
              4.订单在活动时间范围内完成支付才能享受活动优惠，逾期支付则不享受活动优惠；
              5.所有参加本活动的用户，均视为认可并同意遵守<router-link to="/more/terms-of-service">《MoPaaS用户协议》</router-link>。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ThanksGiving',
    data() {
      return {
        dialogVisible: false,
        prices: [{
          id: 0,
          price: 5,
          rule: "满50元赠送"
        }, {
          id: 1,
          price: 15,
          rule: "满100元赠送"
        }, {
          id: 2,
          price: 50,
          rule: "满250元赠送"
        }, {
          id: 3,
          price: 120,
          rule: "满500元赠送"
        }, {
          id: 4,
          price: 250,
          rule: "满1000元赠送"
        }, {
          id: 5,
          price: 800,
          rule: "满2000元赠送"
        }],
        scenes: [{
          id: 0,
          icon: "icon-tuoguan2",
          title: "原型托管",
          content: "轻量级的静态页面类型的应用托管，为您的产品原型提供在线更新、发布和管理能力"
        }, {
          id: 1,
          icon: "icon-wangye",
          title: "静态网页",
          content: "以最小的成本实现静态网站的建站工作，省钱省心"
        }, {
          id: 2,
          icon: "icon-qiye",
          title: "中小企业门户",
          content: "满足中小型企业的门户网站支撑能力，提供常见的开发语言和数据库类型支持"
        }, {
          id: 3,
          icon: "icon-yingyong-gra",
          title: "中小企业应用",
          content: "企业级应用托管，支持常见语言的运行环境，支持多种数据库类型和持久化存储"
        }, {
          id: 4,
          icon: "icon-houtai-",
          title: "移动应用后台",
          content: "满足APP、小程序等移动应用后台管理系统的托管需求，提供完整的底层服务和自动化运维能力"
        }],
        plans: [{
          id: 0,
          title: "CPU套餐01",
          gpu: "RTX 2070*1块",
          cpu: "4核",
          mem: "32GB",
          formerMonth: "4061元",
          currentMonth: "3574元",
          formerYear: "49406元",
          currentYear: "39525元"
        }, {
          id: 1,
          title: "CPU套餐02",
          gpu: "RTX 2070*2块",
          cpu: "8核",
          mem: "64GB",
          formerMonth: "8122元",
          currentMonth: "7147元",
          formerYear: "79050元",
          currentYear: "98813元"
        }]
      }
    }
  }
</script>

<style>
  #thanks-giving {
    overflow: hidden;
    background-color: #1E1965;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #thanks-giving .center-box {
    margin-top: -760px;
    width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #thanks-giving .center-box .section {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #thanks-giving .center-box .pcs .introduce {
    background-image: url(../assets/images/tk-activity-intro-bg.png);
    margin-top: 60px;
    height: 102px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  #thanks-giving .center-box .pcs .introduce p {
    color: #CFDBE9;
    font-size: 24px;
    width: 730px;
    margin-right: 124px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  #thanks-giving .center-box .pcs .introduce p span {
    margin: 0 12px;
    display: inline-block;
    width: 44px;
    height: 38px;
    background: rgba(10, 92, 182, 1);
    border-radius: 4px;
    color: #FEDB79;
    line-height: 38px;
  }

  #thanks-giving .center-box .pcs .introduce a {
    margin-right: 50px;
    font-size: 28px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(234, 248, 251, 1);
    width: 123px;
  }

  #thanks-giving a:hover {
    cursor: pointer;
  }

  #thanks-giving .center-box .pcs .price-box {
    margin-top: 70px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 182px;
  }

  #thanks-giving .center-box .pcs .price-box .price {
    background-image: url(../assets/images/tk-activity-price-bg.png);
    width: 191px;
    height: 182px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #thanks-giving .center-box .pcs .price-box .price h2 {
    /* margin-top: 20px; */
    font-size: 84px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(180, 213, 248, 1);
    line-height: 107px;
  }

  #thanks-giving .center-box .pcs .price-box .price .small-font {
    margin-left: 10px;
    font-size: 73px;
  }

  #thanks-giving .center-box .pcs .price-box .price h5 {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(172, 208, 247, 1);
    line-height: 15px;
  }

  #thanks-giving .center-box .pcs .price-box .price p {
    margin-top: 22px;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(207, 219, 233, 1);
    line-height: 31px;
  }

  #thanks-giving .center-box h5.second-title {

    font-size: 18px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(180, 213, 248, 1);
  }

  #thanks-giving .center-box .pcs .second-title-loc {
    margin: 80px 0 50px 0;
  }

  #thanks-giving .center-box .pcs .scence-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 300px;
  }

  #thanks-giving .center-box .pcs .scence-box .scene {
    width: 210px;
    height: 100%;
    background-color: #0D7BDA;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #thanks-giving .center-box .pcs .scence-box .scene .dot {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 181px;
    height: 269px;
    border: 1px dotted rgba(0, 156, 236, 1);
  }

  #thanks-giving .center-box .pcs .scence-box .scene .dot .icon {
    width: 66px;
    height: 66px;
    background: rgba(2, 91, 192, 1);
    border-radius: 50%;
    margin-top: 31px;
    color: #FEFEFE;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #thanks-giving .center-box .pcs .scence-box .scene .dot .icon i {
    font-size: 36px;
  }

  #thanks-giving .center-box .pcs .scence-box .scene .dot h5 {
    font-size: 14px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin: 25px 0 32px 0;
  }

  #thanks-giving .center-box .pcs .scence-box .scene .dot p {
    width: 132px;
    font-size: 12px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(172, 208, 247, 1);
    line-height: 1.5;
  }

  #thanks-giving .center-box .ai .dot {
    width: 963px;
    height: 99px;
    border: 1px dotted rgba(52, 82, 69, 1);
    margin: 41px 0 80px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #thanks-giving .center-box .ai .dot p {
    width: 892px;
    height: 39px;
    font-size: 14px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(172, 208, 247, 1);
    text-align: left;
    line-height: 1.8;
    letter-spacing: 2.3px;
  }

  #thanks-giving .center-box .ai .plan-box {
    height: 340px;
    margin: 55px 0 79px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  #thanks-giving .center-box .ai .plan-box .plan {
    width: 966px;
    height: 150px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  #thanks-giving .center-box .ai .plan-box .plan .detail {
    width: 346px;
    height: 150px;
    background: rgba(13, 123, 218, 1);
    box-shadow: 5px -1px 10px 0px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    color: #FFFFFF;
  }

  #thanks-giving .center-box .ai .plan-box .plan .detail .title {
    margin: 30px 0 25px 30px;
    font-size: 14px;
    font-family: simhei;
    font-weight: 400;
  }

  #thanks-giving .center-box .ai .plan-box .plan .detail .resources {
    height: 53px;
    font-size: 12px;
    font-family: simhei;
    font-weight: 400;
    margin-left: 53px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  #thanks-giving .center-box .ai .plan-box .plan .detail .resources .content {
    color: #ACD0F7;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .deco-up {
    width: 0px;
    height: 0px;
    border: 12.5px solid rgba(13, 68, 179, 1);
    border-top-color: transparent;
    border-right-color: transparent;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .deco-down {
    width: 0px;
    height: 0px;
    border: 12.5px solid rgba(13, 68, 179, 1);
    border-bottom-color: transparent;
    border-right-color: transparent;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price {
    width: 620px;
    height: 98px;
    background: rgba(204, 228, 255, 1);
    border: 1px solid rgba(7, 43, 117, 1);
    border-left-color: transparent;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    /* align-items: flex-start; */
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price .buy-btn {
    width: 114px;
    height: 36px;
    background: rgba(246, 0, 127, 1);
    border-radius: 2px;
    margin-right: 31px;
    font-size: 14px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 36px;
    align-self: center;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price .left {
    width: 475px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price .left .line {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    font-size: 14px;
    font-family: simhei;
    font-weight: 400;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price .left .line span {
    display: inline-block;
    width: 125px;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price .left .line span.former,
  span.now {
    text-align: left;
    margin-left: 15px;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price .left .line span.former {
    text-decoration: line-through #EF0000;
  }

  #thanks-giving .center-box .ai .plan-box .plan .right-box .price .left .line span.now {
    color: #EF0000;
  }

  #thanks-giving .center-box .weitu .dot {
    width: 963px;
    height: 75px;
    border: 1px dotted rgba(52, 82, 69, 1);
    margin: 41px 0 80px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #thanks-giving .center-box .weitu .dot p {
    width: 892px;
    font-size: 14px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(172, 208, 247, 1);
    text-align: left;
    line-height: 1.8;
    letter-spacing: 2.3px;
  }

  #thanks-giving .center-box .weitu .plan-box {
    height: 725px;
    margin: 55px 0 79px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box {
    width: 963px;
    height: 173px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    color: #FFFFFF;
    font-weight: 400;
    font-family: simhei;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .detail {
    width: 185px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #0063B8;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .detail h3 {
    font-size: 16px;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .detail p {
    font-size: 12px;
    color: #B4D5F8;
    margin: 5px 0 8px 0;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .detail a {
    width: 114px;
    height: 36px;
    background: rgba(246, 0, 127, 1);
    border-radius: 2px;
    color: #FFFFFF;
    font-size: 14px;
    line-height: 36px;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .resources {
    width: 260px;
    height: 100%;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .resources p {
    white-space: pre-wrap;
    text-align: left;
    font-size: 14px;
    color: #B4D5F8;
    line-height: 1.8;
  }

  #thanks-giving .center-box .weitu .plan-box .plan {
    width: 963px;
    height: 237px;
  }

  #thanks-giving .center-box .weitu .plan-box .plan .price-box {
    width: 963px;
    height: 64px;
    background-color: #CCE4FF;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .detail .buy-btn {
    width: 114px;
    height: 36px;
    background: rgba(246, 0, 127, 1);
    border-radius: 2px;
    color: #FFFFFF;
    font-size: 14px;
    line-height: 36px;
    margin-top: 15px;
  }

  #thanks-giving .center-box .weitu .plan-box .intro-box .detail .buy-btn:hover {
    cursor: pointer;
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    height: 37px;
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden .intro {
    width: 185px;
    font-size: 14px;
    font-family: simhei;
    font-weight: 400;
    color: rgba(0, 99, 184, 1);
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden .intro p {
    margin-left: 82px;
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden .price {
    width: 260px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: baseline;
    font-family: simhei;
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden .price:not(:last-child) {
    border-right: 1px solid #5185C0;
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden .price p {
    margin-left: 75px;
    font-size: 14px;
    text-align: left;
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden .price .now {
    color: #EF0000;
  }

  #thanks-giving .center-box .weitu .plan-box .price-box .inner-hidden .price .former {
    color: #1B1557;
    text-decoration: line-through #EF0000;
  }

  #thanks-giving .center-box .rule .rule-box {
    width: 1198px;
    height: 190px;
    background: rgba(13, 123, 218, 1);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
  }

  #thanks-giving .center-box .rule .rule-box .dot {
    width: 1159px;
    height: 150px;
    border: 1px dotted rgba(40, 109, 232, 1);
  }

  #thanks-giving .center-box .rule .rule-box .dot p {
    /* width: 1119px; */
    white-space: pre-wrap;
    text-align: left;
    line-height: 1.8;
    font-size: 14px;
    font-family: simhei;
    color: #ACD0F7;
    margin: -12px 0 0 -35px;
  }

  #thanks-giving .center-box .rule .rule-box .dot p a {
    color: #FF46A1;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/ThanksGiving.vue